// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "default/assets/" + {"104":"52fdd889d08f0f6f3054","168":"4e68dcfb7ad3c86cbd4f","303":"842e4e642e695acc994e","411":"d620c55e70252fac9693","619":"fac57ec786b8936e8409","956":"0d2a93a21fe946debb50"}[chunkId] + "." + chunkId + ".js";
};